import { NodeWithReactions } from '../types';

export const isNodeWithReactions = (
  node: BaseNode
): node is NodeWithReactions => {
  return 'reactions' in node;
};
